import { observer } from "mobx-react-lite";
import React from "react";
import Feedback from "../../../components/templates/Feedback";
import { IconWarningLight, skinVars } from "@telefonica/mistica";
import { strings } from "../../../localization";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useNavigateCustom } from "../../../hooks";

const ExpiredToken: React.FC = observer(() => {
	const { authenticationStore } = useGlobalStore();

	React.useEffect(() => {
		authenticationStore.logout();
	}, []);

	const navigation = useNavigateCustom();
	const {
		pages: {
			expiredToken: { description, title },
		},
		components: {
			buttons: { signin },
		},
	} = strings;
	return (
		<Feedback
			heroDataInfoProps={{
				icon: <IconWarningLight color={skinVars.colors.brand} size={64} />,
				title,
				description,
			}}
			buttonProps={{ textButton: signin, onAction: () => navigation("/login") }}
		/>
	);
});

export default ExpiredToken;
